import React, { useContext, useRef, useState } from "react";
import { Form, message, Button } from "antd";
import { getCookie } from "../../../helpers/localStorage";
import { FacilityID } from "../../../constants/defaultKeys";
import { UserContext } from "../../../context/UserContext";
import { useLocation } from "react-router-dom";
import btnStyles from "../../../styles/Custom/Button.module.css";
import { patientInvestigationsOrderAPI } from "../../../services/patient.services";
import dayjs from "dayjs";
import InitialInvestigationForm from "../../PatientsIP/InvestigationsIp/InitialInvestigationForm";
import "../Doctor/InitialInspection/InitialInspectionHeader.css";

const InvestigationsInitial = ({ setVisible, initialRefresh }) => {
  const location = useLocation();
  const id = Object.fromEntries(new URLSearchParams(location?.search));
  const { userDetails } = useContext(UserContext);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [uploadFile, setUploadFile] = useState([]);
  const [uploadFileLoading, setUploadFileLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    const name = values?.name?.trim() || "";
    const investigationDate = values?.date
      ? dayjs(values.date).format("YYYY-MM-DD")
      : null;
    const reportPath = uploadFile || [];
    if (!name && !investigationDate && reportPath.length === 0) {
      setVisible(false);
      initialRefresh();
      return;
    }

    setLoading(true);
    const formData = {
      facility: Number(getCookie(FacilityID)) || userDetails?.currFacility,
      patient: Number(id?.patient),
      ip_admission: Number(id?.patient),
      name,
      investigation_date: investigationDate,
      report_path: reportPath,
      is_initial: true,
    };

    patientInvestigationsOrderAPI(formData)
      .then((res) => {
        message.success(res?.data?.message);
        setVisible(false);
        setLoading(false);
        initialRefresh();
      })
      .catch((err) => {
        message.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  return (
    <div className="ia-step-shell ia-step-shell--investigation">
      <div className="ia-form-panel">
        <Form
          layout="vertical"
          form={form}
          ref={formRef}
          onFinish={onFinish}
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            minHeight: 0,
          }}
        >
          <div className="ia-form-body">
            <div className="ia-investigation-form">
              <InitialInvestigationForm
                setUploadFile={setUploadFile}
                setUploadFileLoading={setUploadFileLoading}
                uploadFile={uploadFile}
              />
            </div>
          </div>
          <div className="ia-form-footer">
            <Button
              loading={loading}
              disabled={uploadFileLoading}
              htmlType="submit"
              type="primary"
              className={btnStyles.mdBtn}
              style={{ fontWeight: 500 }}
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default InvestigationsInitial;
